export const removeEmptyProps = data => {
  return Object.keys(data).filter(key => data[key] !== '').reduce((acc, key) => ({
    ...acc,
    [key]: data[key]
  }), {});
};